const BASE_NAME = '@@DEEI/GLOBAL/AUTH';

export const SESSION_VALIDATE_REQUEST = `${BASE_NAME}/SESSION/VALIDATE_REQUEST`;
export const SESSION_VALIDATE_SUCCESS = `${BASE_NAME}/SESSION/VALIDATE_SUCCESS`;
export const SESSION_VALIDATE_FAILURE = `${BASE_NAME}/SESSION/VALIDATE_FAILURE`;

export const LOGOUT_REQUEST = `${BASE_NAME}/LOGOUT_REQUEST`;
export const LOGOUT_SUCCESS = `${BASE_NAME}/LOGOUT_SUCCESS`;
export const LOGOUT_FAILURE = `${BASE_NAME}/LOGOUT_FAILURE`;

export const USER_AUTHENTICATED = `${BASE_NAME}/USER_AUTHENTICATED`;
export const USER_LOGGEDOUT = `${BASE_NAME}/USER_LOGGEDOUT`;

export const ACCOUNT_COMBINED = 'ACCOUNT_COMBINED';

export const SET_TOKEN = `${BASE_NAME}/SET_TOKEN`;

export const INACTIVE_SHOW_MODAL = `${BASE_NAME}/INACTIVE_SHOW_MODAL`;
export const INACTIVE_RENEW = `${BASE_NAME}/INACTIVE_RENEW`;
export const INACTIVE_RENEW_REQUEST = `${BASE_NAME}/INACTIVE_RENEW_REQUEST`;

export const INACTIVE_WARNING_TIME = 14 * 60 - 20;
export const INACTIVE_RENEW_TIME = 15 * 60 - 20;
export const INACTIVE_EXPIRED_TIME = 15 * 60;
export const CLOSE_CONCURRENT_REMINDER = `${BASE_NAME}/CLOSE_CONCURRENT_REMINDER`;

export const INIT_STATE = `${BASE_NAME}/INIT_STATE`;
